import React, { useState } from "react";
import { Form, DatePicker, message, Button, Card, notification, Col } from "antd";
import { CisUI } from "../../../util/CISUI";
import "react-smart-data-table/dist/react-smart-data-table.css";
import Config from "../../../util/config";
import axios from "../../../util/Api";

import * as XLXS from "xlsx";

const ImportOpeningBalance = (props) => {
  const [submitted, setSubmitted] = useState(0);

  // const [data, setData] = useState([]);
  const [total, setTotal] = useState({
    debit: 0,
    credit: 0,
  });
  const [dataobject, setDataObject] = useState([]);

  const userID = props.match.params.id;
  // console.log("Userid : "+props.match.params.id);
  let isEdit = 0;
  if (userID > 0) {
    isEdit = 1;
  }

  let newArray = [];

  const onChangeExcel = (e) => {
    let file = e.target.files[0];
    setDataObject([]);
    let debitT = 0;
    let creditT = 0;
    if (file !== "") {
      if (
        file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/x-vnd.oasis.opendocument.spreadsheet"
      ) {
        // console.log(file);
        document.getElementById("loader").style.display = "block";
        let reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = (e) => {
          const bufferArray = e.target.result;
          const wb = XLXS.read(bufferArray, { type: "buffer" });
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          const data1 = XLXS.utils.sheet_to_json(ws);
          // console.log(data1);
          // setData(data1);

          const subsChars = (o) =>
            Object.fromEntries(
              Object.entries(o).map(([k, v]) => [k.replace(/[ \W]/g, (m) => (m === " " ? "_" : "")).toLowerCase(), v]),
            );
          newArray = data1.map(subsChars);

          let newObject = [];
          newArray?.map((dt, index) => {
            let allow = 0;
            if (dt.debit !== undefined) {
              allow = 1;
            }

            if (dt.credit !== undefined) {
              allow = 1;
            }

            if (allow === 1) {
              if (dt.account_number !== undefined) {
                //console.log(dt);
                let newd = {
                  account_number: dt.account_number || "",
                  account_name: dt.account_name || "",
                  // 'fund_program': dt.fund_program || "",
                  // 'functional_expenses': dt.functional_expenses || "",
                  // 'restriction_type': dt.restriction_type || "",
                  debit: dt.debit || 0,
                  credit: dt.credit || 0,
                };

                newObject.push(newd);
              }
            }
          });

          newObject.map((item, index) => {
            debitT += item.debit;
            creditT += item.credit;
          });

          //console.log("AllData : " + JSON.stringify(newObject));
          // console.log("credit : " + creditT);
          setTotal({
            debit: debitT.toFixed(2),
            credit: creditT.toFixed(2),
          });

          if (debitT > 0) {
            if (debitT.toFixed(2) === creditT.toFixed(2)) {
              document.getElementById("msg").style.color = "green";
              document.getElementById("msg").innerText = "";
            } else {
              console.log("Debit " + debitT.toFixed(2));
              console.log("Credit " + creditT.toFixed(2));
              // console.log("Not Equal");
              document.getElementById("msg").style.color = "red";
              document.getElementById("msg").innerText =
                "Total debit and credit value is not same, please check in your file";
            }
          } else {
            if (newObject.length > 0) {
              console.log("Not Worked");
              document.getElementById("msg").style.color = "red";
              document.getElementById("msg").innerText =
                "Total debit and credit value is not same, please check in your file";
            } else {
              document.getElementById("msg").style.color = "red";
              document.getElementById("msg").innerText = "No valid data found, please check your file";
            }
          }

          setDataObject(newObject);

          document.getElementById("loader").style.display = "none";
        };
      } else {
        setTotal({
          debit: 0,
          credit: 0,
        });
        message.error("You can only upload XlXS(Only Excel File) formated file!");
        document.getElementById("loader").style.display = "none";
      }
    }
  };

  const [form] = Form.useForm();

  const onFinish = (values) => {
    // let msg = "Sorry! request not processed, please try again";
    values["data"] = dataobject;
    if (total.debit > 0 && total.debit === total.credit) {
      document.getElementById("loader").style.display = "block";
      axios
        .post(Config.apiserver + "settings/openingbalance", values)
        .then((res) => {
          // console.log(res)
          if (res.data.status === 1) {
            notification.success({
              message: "Success",
              type: "success",
              description: res.data.msg,
            });
            setSubmitted(1);
            setDataObject(res.data.result);
            document.getElementById("msg").style.color = "green";
            document.getElementById("msg").innerText = res.data.msg;
          } else if (res.data.status === 3) {
            notification.success({
              message: "Success",
              type: "success",
              description: res.data.msg,
            });
            setSubmitted(1);
            setDataObject(res.data.result);
            document.getElementById("msg").style.color = "red";
            document.getElementById("msg").innerText = res.data.msg;
          } else {
            notification.warning({
              message: "Alert",
              type: "warning",
              description: res.data.msg,
            });
            document.getElementById("msg").style.color = "green";
            document.getElementById("msg").innerText = res.data.msg;
          }
          document.getElementById("loader").style.display = "none";
        })
        .catch((errors) => {
          document.getElementById("loader").style.display = "none";
          console.log(errors);
        });
    } else {
      notification.warning({
        message: "Alert",
        type: "warning",
        description: "Total debit and credit are not same, please check your file.",
      });
    }
  };

  const getRemark = (text) => {
    if (text === "Success") {
      return <span style={{ color: "green" }}>{text}</span>;
    }
    return text;
  };

  return (
    <Card title={"Import Opening Balance"}>
      {CisUI().showLoading}
      <Form
        form={form}
        {...CisUI().formItemLayout}
        name="input"
        className="ant-advanced-search-form"
        onFinish={onFinish}
        initialValues={{ remember: true }}
      >
        <div className="row">
          <div className="col-md-12">
            <h3>INSTRUCTIONS :</h3>
            <div>
              {CisUI().getUserInfo("comarea") === 3 ? (
                <>
                  1. Download Sample file :{" "}
                  <a
                    style={{ fontWeight: "bold" }}
                    href="https://apiv3.penterp.com/public/upload/tempfile/NationaTemplate.xlsx"
                    target="_blank"
                  >
                    Click to Download
                  </a>
                  <br />
                </>
              ) : (
                ""
              )}
              {CisUI().getUserInfo("comarea") === 4 ? (
                <>
                  1. Download Sample file :{" "}
                  <a
                    style={{ fontWeight: "bold" }}
                    href="https://apiv3.penterp.com/public/upload/tempfile/regiontemplate.xlsx"
                    target="_blank"
                  >
                    Click to Download
                  </a>
                  <br />
                </>
              ) : (
                ""
              )}
              {CisUI().getUserInfo("comarea") === 5 ? (
                <>
                  1. Download Sample file :{" "}
                  <a
                    style={{ fontWeight: "bold" }}
                    href="https://apiv3.penterp.com/public/upload/tempfile/districttemplate.xlsx"
                    target="_blank"
                  >
                    Click to Download
                  </a>{" "}
                  <br />
                </>
              ) : (
                ""
              )}
              {CisUI().getUserInfo("comarea") === 6 ? (
                <>
                  1. Download Sample file :{" "}
                  <a
                    style={{ fontWeight: "bold" }}
                    href="https://apiv3.penterp.com/public/upload/tempfile/localtemplate.xlsx"
                    target="_blank"
                  >
                    Click to Download
                  </a>{" "}
                  <br />
                </>
              ) : (
                ""
              )}
            </div>
            <div>
              2. Enter your debit or credit balance on excel file <br />
              3. Verify that the total debit and total credit are the same.
              <br />
              4. Once done, use the “Click to Upload” option to load. <br />
              <div className="row" style={{ margin: "20px" }}>
                <div className="col-md-4" style={{ display: "none" }}>
                  <Form.Item
                    name="date"
                    label="Date"
                    rules={[
                      {
                        required: false,
                        message: "Select a date",
                      },
                    ]}
                  >
                    <DatePicker format={CisUI().dateFormat} className="gx-mb-3 gx-w-100" placeholder="Date" />
                  </Form.Item>
                </div>
                <div className="col-md-4">
                  <div style={{ fontWeight: "bold", paddingBottom: "10px" }}>Choose your Excel File</div>
                  <input type="file" onChange={onChangeExcel} />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12" style={{ textAlign: "center" }}>
                  <h3 style={{ color: "red" }} id="msg"></h3>
                </div>
              </div>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Account Code</th>
                    <th>Account Name</th>
                    {/*<th>Fund Program</th>*/}
                    {/*<th>Functional Expense</th>*/}
                    {/*<th>Restriction Type</th>*/}
                    <th style={{ textAlign: "right" }}>Debit</th>
                    <th style={{ textAlign: "right" }}>Credit</th>
                    {submitted === 1 ? <th>Result</th> : ""}
                  </tr>
                </thead>
                <tbody>
                  {dataobject.map((dt, index) => (
                    <tr>
                      <td>{dt.account_number}</td>
                      <td>{dt.account_name}</td>

                      <td style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(dt.debit ?? 0)}</td>
                      <td style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(dt.credit ?? 0)}</td>
                      {submitted === 1 ? <th style={{ paddingLeft: "10px" }}>{getRemark(dt.remark)}</th> : ""}
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <th colSpan={2}>Total</th>
                    <th style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(total.debit)}</th>
                    <th style={{ textAlign: "right" }}>{CisUI().getCurrencyFormated1(total.credit)}</th>
                    {submitted === 1 ? <th></th> : ""}
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
        <Col lg={24} xs={24} style={{ textAlign: "center" }}>
          {total.debit > 0 ? (
            total.debit === total.credit ? (
              submitted === 0 ? (
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              ) : (
                ""
              )
            ) : (
              ""
            )
          ) : (
            ""
          )}
        </Col>
      </Form>
    </Card>
  );
};

export default ImportOpeningBalance;
